import fetch from "auth/FetchInterceptor";
import store from "redux/store";

const JwtAuthService = {};

JwtAuthService.login = async function (personalKey, password) {
  var data = { personalKey: personalKey, password: password };
  return await fetch.post("api/auth/LoginAdmin", data, {
    headers: {
      "public-request": "true",
    },
  });
};

JwtAuthService.logout = async function () {
  const jwtToken = store.getState().auth.token;

  return await fetch.post("api/auth/Logout", null, {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  });
};

JwtAuthService.signUp = function (data) {
  return fetch({
    url: "/auth/signup",
    method: "post",
    headers: {
      "public-request": "true",
    },
    data: data,
  });
};

export default JwtAuthService;
